import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';

import UserApplyInviteCodeModal from "./UserApplyInviteCodeModal";
import getUserInfo from "../../common/util/getUserInfo";

export default class AccountBannedModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = false;

  oninit(vnode) {
    super.oninit(vnode);
  }

  className() {
    return 'Modal--medium';
  }

  title() {
    return app.translator.trans('ziven-u2di.lib.confirmation');
  }

  content() {
    const userInfoData = getUserInfo(app.session.user.id());
    const from = "indexPage"

    return (
      <div className="Modal-body" style="padding-top: 0px;">
        <div className="Form" style="text-align:center">
          <div style="font-size: 16px;padding-bottom: 20px;height: 60px;">
            {app.translator.trans('ziven-u2di.forum.error-account-expired')}
          </div>
          <div>
            {Button.component({
                className: 'Button U2DiButton--green',
                disabled: this.loading,
                onclick: () => {
                  app.modal.show(UserApplyInviteCodeModal,{userInfoData,from});
                }
              },
              app.translator.trans('ziven-u2di.forum.button-extend_expiration')
            )}&nbsp;
            {Button.component({
                className: 'Button Button--primary',
                disabled: this.loading,
                onclick: () => {
                  app.session.logout();
                }
              },
              app.translator.trans('ziven-u2di.forum.title-user-logout')
            )}
          </div>
        </div>
      </div>
    );
  }
}
